var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.0093H6.425L16.2 9.23428L14.775 7.80928L5 17.5843V19.0093ZM3 21.0093V16.7593L16.2 3.58428C16.4 3.40094 16.6208 3.25928 16.8625 3.15928C17.1042 3.05928 17.3583 3.00928 17.625 3.00928C17.8917 3.00928 18.15 3.05928 18.4 3.15928C18.65 3.25928 18.8667 3.40928 19.05 3.60928L20.425 5.00928C20.625 5.19261 20.7708 5.40928 20.8625 5.65928C20.9542 5.90928 21 6.15928 21 6.40928C21 6.67594 20.9542 6.93011 20.8625 7.17178C20.7708 7.41344 20.625 7.63428 20.425 7.83428L7.25 21.0093H3ZM15.475 8.53428L14.775 7.80928L16.2 9.23428L15.475 8.53428Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7757ccd04fd3c00ef57bdf73ffcad5f9.svg";
export { ForwardRef as ReactComponent };